
        import introJs from 'intro.js';
        window.introJs = introJs;
    